export default "__VITE_ASSET__CIE7rGwk__"